import React from "react";
import { MdPersonAddAlt1 } from "react-icons/md";
import "./AssignUser.css";
import { Tooltip } from "../Tooltip";

export function AssignUser({ onClick, isActive }) {

  return (
    <div className="toolbar-button-wrapper">
      <button onClick={onClick} className="assign-user-button">
        <MdPersonAddAlt1 />
      </button>
      {isActive && <div className="button-underline assign-user-underline" />}
    </div>
  );
}
